import React from 'react';
import { map, find } from 'lodash';
import classNames from 'classnames';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { ACCESS_MANAGEMENT_USER_GROUPS_MODE, CREATE_USER_GROUP_TABS } from 'constants/common';
import { accessManagementUserGroupsCreateModeGroupTab as AccessManagementUserGroupsCreateModeGroupTabView } from 'ui/views/widgets/accessManagementUserGroupsCreateModeGroupTab';
import { accessManagementUserGroupsCreateModeUsersTab as AccessManagementUserGroupsCreateModeUsersTabView } from 'ui/views/widgets/accessManagementUserGroupsCreateModeUsersTab';

const TAB_VIEWS = {
    [ CREATE_USER_GROUP_TABS.USER_GROUP_TAB ]: AccessManagementUserGroupsCreateModeGroupTabView,
    [ CREATE_USER_GROUP_TABS.USERS_TAB ]: AccessManagementUserGroupsCreateModeUsersTabView
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { accessManagementUserGroupsCreateMode as AccessManagementUserGroupsCreateMode } from 'ui/views/widgets/accessManagementUserGroupsCreateMode';
 *
 * // render
 * <AccessManagementUserGroupsCreateMode propName='propValue'/>
 */
export const accessManagementUserGroupsCreateMode = ( {
    formData,
    selectedPermissions,
    errorMessage,
    isSearchingUsers,
    usersSearchQuery,
    userSearchResults,
    addedUsers,
    mode,
    createUserGroupSection,
    selectedTab,
    selectedTabObj,
    options,
    onCancelActionClick,
    onGoToUsersActionClick,
    onPermissionSelect,
    onSubmitFormData,
    onUserSearch,
    onUserAdd,
    onUserRemove,
    onGoToInformationActionClick,
    onFormDataChange
} ) => {
    const TabView = TAB_VIEWS[ selectedTab ];

    return (
        <div className='ui-access-management-user-groups-create-mode__create-section'>

            {/* Title */}
            <div className='ui-access-management-user-groups-create-mode__create-section__title'>
                {
                    ACCESS_MANAGEMENT_USER_GROUPS_MODE.EDIT === mode ?
                    getLabel( { refId: 'displayTitleUpdatePermissions', value: '' } ) :
                    getLabel( find( createUserGroupSection.titleMap, { name: selectedTab } ).title )
                }
            </div>

            {/* Tabs */}
            <div className='ui-access-management-user-groups-create-mode__create-section__tabs'>
                {
                    map( createUserGroupSection.tabs, tab => {
                        const tabClassName = classNames( 'ui-access-management-user-groups-create-mode__create-section__tabs__tab', {
                            'ui-access-management-user-groups-create-mode__create-section__tabs__tab--selected': tab.name === selectedTab
                        } );

                        return (
                            <div
                                key={ tab.name }
                                className={ tabClassName }
                            >
                                { getLabel( tab.title ) }
                            </div>
                        );
                    } )
                }
            </div>

            <div className='ui-access-management-user-groups-create-mode__create-section__tab'>

                {/* Validaton Error, if available */}
                {
                    errorMessage && (
                        <div className='ui-access-management-user-groups-create-mode__create-section__tab__message'>
                            <div className='ui-access-management-user-groups-create-mode__create-section__tab__message__icon'>
                                <Icon id='invalidGroupNameMessage' />
                            </div>
                            <div className='ui-access-management-user-groups-create-mode__create-section__tab__message__text'>
                            { errorMessage }
                            </div>
                        </div>
                    )
                }

                {/* Tab View */}
                <TabView
                    formData={ formData }
                    selectedPermissions={ selectedPermissions }
                    isSearchingUsers={ isSearchingUsers }
                    usersSearchQuery={ usersSearchQuery }
                    userSearchResults={ userSearchResults }
                    addedUsers={ addedUsers }
                    selectedTabObj={ selectedTabObj }
                    options={ options }
                    onCancelActionClick={ onCancelActionClick }
                    onGoToUsersActionClick={ onGoToUsersActionClick }
                    onPermissionSelect={ onPermissionSelect }
                    onSubmitFormData={ onSubmitFormData }
                    onUserSearch={ onUserSearch }
                    onUserAdd={ onUserAdd }
                    onUserRemove={ onUserRemove }
                    onGoToInformationActionClick={ onGoToInformationActionClick }
                    onFormDataChange={ onFormDataChange }
                />
            </div>
        </div>
    );
};

// set display name
accessManagementUserGroupsCreateMode.displayName = 'accessManagementUserGroupsCreateMode';

// set default props
accessManagementUserGroupsCreateMode.defaultProps = {};

// prop types
accessManagementUserGroupsCreateMode.propTypes = {};
